import BackgroundModalPattern from '../assets/Background-pattern-decorative.svg';
import DecompInightsContentItemReleaseNote from '../assets/DecompInsightsContentitem.png';
import DecompInightsDriverReleaseNote from '../assets/Decompdrivers.png';
import DemandModelDrillThroughReleaseNotes from '../assets/DemandModelDrillThroughReleaseNotes.png';
import DemandModelReleaseNotes from '../assets/DemandModelReleaseNotes.png';
import ContactUsImage from '../assets/Image-laptop-keyboard.jpg';
import ProActiveAlertReleaseNote from '../assets/ProActiveAlertReleaseNote.png';
import ProfileAvatar from '../assets/Swatch.png';
import BackgroundCardsImage from '../assets/backgroundCards.png';
import VideoBannerGradientImage from '../assets/gradient-img.png';
import HamIcon from '../assets/icons/Hamicon.svg';
import PlayButtonIcon from '../assets/icons/Play-button.svg';
import TeamsIcon from '../assets/icons/Teams.svg';
import ReportProblemIcon from '../assets/icons/alert-circle.png';
import ArrowDownIcon from '../assets/icons/arrow-down.svg';
import ArrowLeftSideIcon from '../assets/icons/arrow-left.svg';
import ArrowLeftIcon from '../assets/icons/arrow-narrow-left.svg';
import ArrowRightSideIcon from '../assets/icons/arrow-right.svg';
import ArrowUpIcon from '../assets/icons/arrow-up.svg';
import BarChartSquareUp from '../assets/icons/bar-chart-square-up.svg';
import BarChartLine from '../assets/icons/bar-chart-square.svg';
import BarLineChartIcon from '../assets/icons/bar-line-chart.svg';
import BookClosedIcon from '../assets/icons/book-closed.svg';
import CalendarIcon from '../assets/icons/calendar.svg';
import ChartBreakoutCircleIcon from '../assets/icons/chart-breakout-circle.svg';
import ChartsImage from '../assets/icons/chartinsightimage.svg';
import ChartsImagetwo from '../assets/icons/chartinsightimage2.svg';
import CheckCircleBrokenIcon from '../assets/icons/check-circle-broken.svg';
import CheckIcon from '../assets/icons/check.svg';
import ChevronDownIcon from '../assets/icons/chevron-down.svg';
import ArrowRightIcon from '../assets/icons/chevron-right.svg';
import CopyIcon from '../assets/icons/copy.svg';
import CreditCardRefresh from '../assets/icons/credit-card-refresh.svg';
import CurrencyDollarCircleIcon from '../assets/icons/currency-dollar-circle.svg';
import DotsIcon from '../assets/icons/dots-vertical.svg';
import DownloadIcon from '../assets/icons/download.svg';
import DragIcon from '../assets/icons/drag-icon.svg';
import DrillThroughIcon from '../assets/icons/drill-through.svg';
import EditIcon from '../assets/icons/edit-02.svg';
import EditOrangeIcon from '../assets/icons/edit-03.svg';
import ExcelFileIcon from '../assets/icons/excel.svg';
import ExpandIcon from '../assets/icons/expand-01.svg';
import FileIcon from '../assets/icons/file-05.svg';
import PDFIcon from '../assets/icons/file-06.svg';
import FileCodeIcon from '../assets/icons/file-code.svg';
import FilterFunnelIcon from '../assets/icons/filter-funnel-01.svg';
import FlagIcon from '../assets/icons/flag-04.svg';
import HeartIcon from '../assets/icons/heart.svg';
import HomeLineIcon from '../assets/icons/home-line.svg';
import RightArrowupIcon from '../assets/icons/icon001.svg';
import LineChartUpIcon from '../assets/icons/line-chart-up-05.svg';
import LineChartUpActiveIcon from '../assets/icons/line-chart-up-4.svg';
import LineChartUp from '../assets/icons/line-chart-up.svg';
import ExternalLink from '../assets/icons/link-external.svg';
import LockUnlockedIcon from '../assets/icons/lock-unclocked.svg';
import logoutIcon from '../assets/icons/log-out.svg';
import MailIcon from '../assets/icons/mail-01.svg';
import MessageCircleIcon from '../assets/icons/message-circle.svg';
import MessageSmileSquareIcon from '../assets/icons/message-smile-square.svg';
import MonitorIcon from '../assets/icons/monitor.svg';
import NetFlow from '../assets/icons/netflow-default.svg';
import OutlookSmallIcon from '../assets/icons/outlook-small.svg';
import OutlookIcon from '../assets/icons/outlook.svg';
import PanelCloseIcon from '../assets/icons/panel-close.svg';
import PieChartIcon from '../assets/icons/pie-chart.svg';
import PlayBlueIcon from '../assets/icons/play-circle.svg';
import PrinterIcon from '../assets/icons/printer.svg';
import ProActiveAlertIcon from '../assets/icons/proactive-alert.svg';
import ResetIcon from '../assets/icons/reset-icon.svg';
import PlannerIcon from '../assets/icons/scenario-planner.svg';
import ShareIcon from '../assets/icons/share-07.svg';
import ShoppingBag from '../assets/icons/shopping-bag.svg';
import SimpleArrow from '../assets/icons/simple-arrow.svg';
import SlashCircle from '../assets/icons/slash-circle.svg';
import StarIcon from '../assets/icons/star-01.svg';
import StarIcon2 from '../assets/icons/star-02.svg';
import StarActiveIcon from '../assets/icons/star-active.svg';
import StarsBlueIcon from '../assets/icons/stars-blue.svg';
import SwitchHorizantalIcon from '../assets/icons/switch-horizontal.svg';
import UsersIcon from '../assets/icons/users.svg';
import CloseWhiteIcon from '../assets/icons/x-close-white.svg';
import CloseIcon from '../assets/icons/x-close.svg';
import BarChartSquare from '../assets/menuicons/bar-chart-square-up.svg';
import BookOpen from '../assets/menuicons/book-open.svg';
import Calculator from '../assets/menuicons/calculator.svg';
import CalenderDate from '../assets/menuicons/calendar-date.svg';
import CurrencyDollarCircle from '../assets/menuicons/currency-dollar-circle.svg';
import ElasticViewer from '../assets/menuicons/elasticity-viewer.svg';
import Flag from '../assets/menuicons/flag-04.svg';
import MessageQuestionCircle from '../assets/menuicons/message-question-circle.svg';
import Play from '../assets/menuicons/play.svg';
import PriceBandwidth from '../assets/menuicons/price-bandwith.svg';
import RangeFinder from '../assets/menuicons/range-finder.svg';
import RefreshIcon from '../assets/menuicons/refresh-cw.svg';
import SearchBarchart from '../assets/menuicons/search-barchart.svg';
import PlayIcon from '../assets/play-circle.svg';
import TableCellImage from '../assets/table-cell.png';
import VerticalDummyImage from '../assets/vertical-Image.png';

export const IMAGES_REPO = {
  ArrowDownIcon,
  ArrowLeftIcon,
  ArrowLeftSideIcon,
  ArrowRightIcon,
  ArrowRightSideIcon,
  ArrowUpIcon,
  BackgroundCardsImage,
  BackgroundModalPattern,
  BarChartLine,
  BarChartSquare,
  BarChartSquareUp,
  BarLineChartIcon,
  BookClosedIcon,
  BookOpen,
  Calculator,
  CalendarIcon,
  CalenderDate,
  ChartBreakoutCircleIcon,
  ChartsImage,
  ChartsImagetwo,
  CheckCircleBrokenIcon,
  CheckIcon,
  ChevronDownIcon,
  CloseIcon,
  CloseWhiteIcon,
  ContactUsImage,
  CopyIcon,
  CreditCardRefresh,
  CurrencyDollarCircle,
  CurrencyDollarCircleIcon,
  DecompInightsContentItemReleaseNote,
  DecompInightsDriverReleaseNote,
  DemandModelDrillThroughReleaseNotes,
  DemandModelReleaseNotes,
  DotsIcon,
  DownloadIcon,
  DragIcon,
  DrillThroughIcon,
  EditIcon,
  EditOrangeIcon,
  ElasticViewer,
  ExcelFileIcon,
  ExpandIcon,
  ExternalLink,
  FileCodeIcon,
  FileIcon,
  FilterFunnelIcon,
  Flag,
  FlagIcon,
  HamIcon,
  HeartIcon,
  HomeLineIcon,
  LineChartUp,
  LineChartUpActiveIcon,
  LineChartUpIcon,
  LockUnlockedIcon,
  MailIcon,
  MessageCircleIcon,
  MessageQuestionCircle,
  MessageSmileSquareIcon,
  MonitorIcon,
  NetFlow,
  OutlookIcon,
  OutlookSmallIcon,
  PDFIcon,
  PanelCloseIcon,
  PieChartIcon,
  PlannerIcon,
  Play,
  PlayBlueIcon,
  PlayButtonIcon,
  PlayIcon,
  PriceBandwidth,
  PrinterIcon,
  ProActiveAlertIcon,
  ProActiveAlertReleaseNote,
  ProfileAvatar,
  RangeFinder,
  RefreshIcon,
  RightArrowupIcon,
  SearchBarchart,
  ShareIcon,
  ShoppingBag,
  SimpleArrow,
  SlashCircle,
  StarActiveIcon,
  StarIcon,
  StarIcon2,
  StarsBlueIcon,
  SwitchHorizantalIcon,
  TableCellImage,
  TeamsIcon,
  UsersIcon,
  VerticalDummyImage,
  VideoBannerGradientImage,
  logoutIcon,
  ResetIcon,
  ReportProblemIcon,
};
